import React, { Component } from 'react';
import { Line } from 'react-chartjs-2';
import { isLoaded } from 'react-redux-firebase';

import Chart from 'common/components/Chart';
import Loading from 'common/components/Loading';

class BalanceForecast extends Component {

    formatTitle = (item, data) => {
        let index = item[0].index;
        let day = this.props.days[index];

        return day.title;
    }

    formatLabel = (item, data) => {
        let label = data.datasets[item.datasetIndex].label || '';

        return `${label}: $${item.yLabel.toFixed(2)}`;
    }

    render() {
        const {
            days,
            monthProjection,
            pointColors,
            today
        } = this.props;

        if (!isLoaded(days, monthProjection, pointColors, today)) {
            return <Loading />;
        }

        return (
            <Chart component={Line}
                data={{
                    labels: days.map(d => d.number),
                    datasets: [
                        {
                            label: 'Balance',
                            data: days.map(d => d.mdate.isSameOrBefore(today, 'day') ? d.balance : null),
                            backgroundColor: 'transparent',
                            borderColor: 'rgba(32, 201, 151, .7)',
                            pointBackgroundColor: pointColors,
                            pointBorderColor: pointColors,
                            pointHoverBorderColor: 'rgba(32, 201, 151, .7)',
                            pointHoverBackgroundColor: 'rgba(32, 201, 151, .7)'
                        },
                        {
                            label: 'Balance without New Transactions',
                            data: days.map(d => d.mdate.isSameOrAfter(today, 'day') ? d.balance : null),
                            backgroundColor: 'transparent',
                            borderColor: 'rgba(32, 201, 151, .7)',
                            borderDash: [10, 10],
                            pointBorderColor: 'transparent',
                            pointHoverBorderColor: 'rgba(32, 201, 151, .7)',
                            pointHoverBackgroundColor: 'rgba(32, 201, 151, .7)'
                        },
                        {
                            label: 'Balance with Avg. Daily Spend',
                            data: monthProjection.map(d => d.mdate.isSameOrAfter(today, 'day') ? d.balance : null),
                            backgroundColor: 'transparent',
                            borderColor: 'rgba(180, 180, 180, .7)',
                            borderDash: [10, 10],
                            pointBorderColor: 'transparent',
                            pointHoverBorderColor: 'rgba(180, 180, 180, .7)',
                            pointHoverBackgroundColor: 'rgba(180, 180, 180, .7)'
                        }
                    ]
                }} options={{
                    legend: {
                        display: false
                    },
                    elements: {
                        line: {
                            fill: false
                        }
                    },
                    scales: {
                        xAxes: [{
                            scaleLabel: {
                                display: true,
                                labelString: 'Day of the Month'
                            },
                            ticks: {
                                autoSkip: true,
                                maxTicksLimit: 15,
                                stepSize: 1
                            }
                        }],
                        yAxes: [{
                            ticks: {
                                callback: value => '$' + value
                            }
                        }]
                    },
                    tooltips: {
                        callbacks: {
                            title: this.formatTitle,
                            label: this.formatLabel
                        }
                    }
                }}/>
        );
    }
}

export default BalanceForecast;